module.exports = __webpack_public_path__ + "static/media/valentina_guerrero_marin_4.4aab99fb.jpg";